import { MouseEvent, ReactNode } from "react"
import cn from "classnames"

import { Box, Img, Text, Button } from "ui-kit/components-branded/index"
import { MyUserInfoLink } from "app/AppRouter/links"
import { Analytics } from "utils/analytics"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"

interface AdviceBlockProps {
    title: ReactNode
    description: ReactNode
    button: ReactNode
    className?: string
}

export function AdviceBlock({ title, description, button, className }: AdviceBlockProps) {
    return (
        <div className={cn("advice-block", className)}>
            <div className="advice-block__emoji">
                <Img src="regular-emoji.gif" />
            </div>
            <Box className="advice-block__content is-relative">
                <div className="is-flex">
                    <div className="advice-block__content">
                        <div className="advice-block__title">{title}</div>
                        <Text className="is-block mgb-3">{description}</Text>
                    </div>
                    <div className="advice-block__emoji-mobile flex-shrink-0">
                        <Img src="regular-emoji-mobile.gif" />
                    </div>
                </div>
                {button}
            </Box>
        </div>
    )
}

function CustomButton({
    text,
    onClick,
}: {
    text: string
    onClick?: (event: MouseEvent<HTMLButtonElement>) => void
}) {
    return (
        <Button isResponsive onClick={onClick} className="advice-block__button">
            {text}
        </Button>
    )
}

function ButtonUrl({
    text,
    hash,
    onClick,
}: {
    text: string
    hash?: string
    onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
}) {
    return (
        <MyUserInfoLink
            className="button-secondary advice-block__button is-responsive"
            hash={hash}
            onClick={onClick}
        >
            <Text isAccent>{text}</Text>
        </MyUserInfoLink>
    )
}

AdviceBlock.Button = CustomButton
AdviceBlock.ButtonUrl = ButtonUrl

export function AdviceBlockDiscount({ className }: { className: string }) {
    const [{ userAccount: clientUserAccount }] = useClientContext()
    const isB2b = clientUserAccount.is_b2b

    const title = isB2b ? (
        <>Подарите 3&nbsp;сессии со&nbsp;скидкой&nbsp;30%</>
    ) : (
        <>Получите 4&nbsp;сессии со&nbsp;скидкой&nbsp;10%</>
    )

    const description = isB2b ? (
        <>
            Отправьте другу ссылку и&nbsp;он&nbsp;получит скидку&nbsp;30% на&nbsp;первые
            3&nbsp;сессии.
        </>
    ) : (
        <>
            Отправьте другу скидку на&nbsp;терапию и&nbsp;сэкономьте&nbsp;10% на&nbsp;следующие
            4&nbsp;сессии.
        </>
    )

    const button = (
        <AdviceBlock.ButtonUrl
            text={isB2b ? "Подарить скидку" : "Получить скидку"}
            onClick={() => Analytics.ref_main_clicked()}
        />
    )

    return (
        <AdviceBlock
            className={className}
            title={title}
            description={description}
            button={button}
        />
    )
}
